import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { OrganizationUserDetails } from '@/components/organizations/OrganizationUserDetails';
import { backendApiOrganizationsFindOneOrganizationUserOptions } from '@/modules/api/@tanstack/react-query.gen';

export const Route = createFileRoute(
  '/_authenticated/_management/administration/organisationen/$organizationId/benutzerinnen/$userId',
)({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: OrganizationUserDetailsRoute,
});

function OrganizationUserDetailsRoute() {
  const { userId, organizationId } = Route.useParams();

  const { data: organizationUser } = useQuery(
    backendApiOrganizationsFindOneOrganizationUserOptions({ path: { userId, organizationId } }),
  );

  return (
    organizationUser && (
      <OrganizationUserDetails
        organizationUser={organizationUser}
        parentRoute="/administration/organisationen/$organizationId"
      />
    )
  );
}
